/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo200,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo401,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo404,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo500,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoPathParams,
  GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoQueryResponse,
} from "../../types/individualPaymentLookupsController/GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo.ts";
import { individualPaymentCourseFinancialInfoViewModelSchema } from "../individualPaymentCourseFinancialInfoViewModelSchema.ts";

export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoPathParamsSchema =
  z.object({
    courseFinancialId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo200Schema =
  z.lazy(
    () => individualPaymentCourseFinancialInfoViewModelSchema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo404Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo500>;

export const getApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfo200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentCourseFinancialsCoursefinancialidInfoQueryResponse>;
